import { create } from 'zustand';

/**
 * ImageSearch 状态管理
 * 用于管理图片搜索相关的全局状态
 */
interface ImageSearchStore {
  /**
   * 是否置顶显示
   * - true: 置顶（loading、未付费状态）
   * - false: 不置顶（落地页、已付费状态）
   */
  isPinned: boolean;

  /**
   * 设置置顶状态
   * @param pinned 是否置顶
   */
  setIsPinned: (pinned: boolean) => void;

  /**
   * 切换置顶状态
   */
  togglePinned: () => void;

  /**
   * 是否打开/显示
   * - true: 打开（默认）
   * - false: 关闭
   */
  open: boolean;

  /**
   * 设置打开状态
   * @param open 是否打开
   */
  setOpen: (open: boolean) => void;
}

export const useImageSearchStore = create<ImageSearchStore>((set) => ({
  // 初始状态：不置顶
  isPinned: false,

  // 设置置顶状态
  setIsPinned: (pinned: boolean) => set({ isPinned: pinned }),

  // 切换置顶状态
  togglePinned: () => set((state) => ({ isPinned: !state.isPinned })),

  // 初始状态：打开
  open: true,

  // 设置打开状态
  setOpen: (open: boolean) => set({ open }),
}));
